import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const CellColor = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.68045 2.12209C4.51536 1.9593 4.24769 1.9593 4.0826 2.12209C3.91751 2.28488 3.91751 2.54882 4.0826 2.71161L5.33613 3.94765L1.87146 7.364C1.37618 7.85237 1.37618 8.64417 1.87146 9.13254L6.43631 13.6337C6.93158 14.1221 7.73459 14.1221 8.22986 13.6337L13.3926 8.54303C13.5577 8.38024 13.5577 8.1163 13.3926 7.95351L7.63201 2.2733C7.46692 2.11051 7.19925 2.11051 7.03416 2.2733L5.93398 3.35814L4.68045 2.12209ZM5.93398 4.53716L2.46931 7.95351C2.38676 8.03491 2.34549 8.1416 2.34549 8.24829L12.4958 8.24829L7.33309 3.15757L6.53183 3.94765L7.62781 5.02835C7.80905 5.10256 7.95393 5.24571 8.02882 5.4246C8.17306 5.58275 8.17305 5.82349 8.02878 5.98162C7.91774 6.24676 7.65295 6.43334 7.34396 6.43334C6.93494 6.43334 6.60336 6.10638 6.60336 5.70306C6.60336 5.55885 6.64575 5.42439 6.71893 5.31116L5.93398 4.53716Z"
        fill={color}
      />
      <path
        d="M12.8968 10.8513C12.5285 11.3722 12.089 11.9938 12.089 12.6154C12.089 13.2097 12.3903 13.8041 13.2945 13.8041C14.1986 13.8041 14.5 13.2097 14.5 12.6154C14.5 11.9938 14.0605 11.3722 13.6922 10.8513C13.6116 10.7374 13.5344 10.6282 13.466 10.525C13.3898 10.4099 13.1992 10.4099 13.1229 10.525C13.0545 10.6282 12.9774 10.7374 12.8968 10.8513Z"
        fill={color}
      />
    </svg>
  )
})

export default CellColor
